import { render, staticRenderFns } from "./BDXStatusPendingManagerListHeader.vue?vue&type=template&id=086408ad&scoped=true"
import script from "./BDXStatusPendingManagerListHeader.vue?vue&type=script&lang=js"
export * from "./BDXStatusPendingManagerListHeader.vue?vue&type=script&lang=js"
import style0 from "./BDXStatusPendingManagerListHeader.vue?vue&type=style&index=0&id=086408ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086408ad",
  null
  
)

export default component.exports